import { createContext, useContext, type ReactNode } from 'react';
import type { MeDto, Permission } from '@hv/shared';

interface AuthValue {
  me: MeDto;
  can: (permission: Permission) => boolean;
}

const AuthContext = createContext<AuthValue | null>(null);

export function AuthProvider({ me, children }: { me: MeDto; children: ReactNode }) {
  const can = (permission: Permission) => me.permissions.includes(permission);
  return <AuthContext.Provider value={{ me, can }}>{children}</AuthContext.Provider>;
}

export function useAuth(): AuthValue {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used inside AuthProvider');
  return ctx;
}
